import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { ParametroModel } from 'model/api/gestao/parametro/parametro-model';

export function useGetParametros() {
  const { invocarApi, ...outrasPropriedades } =
    useApiBase<ApiListModel<ParametroModel>>();

  const getParametros = useCallback(async () => {
    return invocarApi({
      url: `${VariaveisAmbiente.apiVersion}/parametro?page=1&size=1000`,
      method: 'GET',
      enviarTokenUsuario: true,
    });
  }, [invocarApi]);
  return {
    ...outrasPropriedades,
    getParametros,
  };
}
